import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BasicMachineFunctionsService } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { IdleTimerService } from 'src/app/services/helper/idleTimer/idle-timer.service';
import { RoleService } from 'src/app/services/helper/role-handling-helper';

@Component({
  selector: 'app-direct-connection',
  templateUrl: './direct-connection.component.html',
  styleUrls: ['./direct-connection.component.scss']
})
export class DirectConnectionComponent implements OnInit, OnDestroy {

  machinenr: string = '';
  subscription: any;
  dialogRef!: MatDialogRef<DirectConnectionDialogComponent>;

  constructor(private activatedRoute: ActivatedRoute, public roleService: RoleService, private router: Router, public dialog: MatDialog, private machineService: BasicMachineFunctionsService, private global: GlobalService, private gatewayService: GatewayConnectionService, private idleService: IdleTimerService){}
  
  ngOnInit(): void {
    this.dialogRef = this.dialog.open(DirectConnectionDialogComponent, {width: '50%', data: {loading: true}, disableClose: true});
    setTimeout(()=> {
      if(this.roleService.isRole('Basic')) {
        this.checkConnection();
      } else {
        this.router.navigateByUrl("/denied");
      }
    }, 500);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.dialogRef?.close();
  }

  private checkConnection() {
    this.activatedRoute.params.subscribe((params) => {
      this.machinenr = params['machinenr'];
      this.dialogRef.componentInstance.machinenr = this.machinenr.toUpperCase();
      this.dialogRef.componentInstance.loading = false;
      //this.dialogRef = this.dialog.open(DirectConnectionDialogComponent, {width: '50%', data: {machinenr: this.machinenr}, disableClose: true});
    });
    this.subscription = this.machineService.getExchangeToken().subscribe((res) => {
        let response = JSON.parse(JSON.stringify(res.body));
        this.subscription = this.machineService.getMachine(this.machinenr, response.access_token).subscribe({
          next: (resp) => {
            let machine = JSON.parse(JSON.stringify(resp.body));
            if(machine._embedded != undefined){
              if(machine._embedded.items.length == 1) {
                let option = machine._embedded.items[0];
                this.global.variables.next({attempt: true});
                this.subscription = this.gatewayService.connectToMachine(option).subscribe({
                  next: (resp) => {
                    if(option.eolTestDone === false) {
                      this.global.comission.next({enabled: true});
                    }
                    this.dialogRef.close();
                    this.idleService.startWatching();
                    this.router.navigate(['/menu']); 
                    this.global.machineNumber.next({ number: option.serialNumber, id: option.id, series: option.machineSeries });
                    if(option.type.line == 'crane') {
                      option.type.line = 'green';
                    }
                    this.global.machineInfos.next({line: option.type.line, name:option.type.name, engine: option.engineType});
                    this.global.variables.next({connected: true});
                  }, 
                  error: (error) => {
                    console.warn(error);
                    this.dialogRef.componentInstance.continue = false;
                    if(error.error['Error']?.includes('DOIP')) {
                      this.dialogRef.componentInstance.errorMessage = "DIRECT_CONN.ERROR.DOIP_CON";
                    } else if(error.error['Error']?.includes('bridge')) {
                      this.dialogRef.componentInstance.errorMessage = "DIRECT_CONN.ERROR.BRIDGE";
                    } else {
                      this.dialogRef.componentInstance.errorMessage = "DIRECT_CONN.ERROR.DID_MAP";
                    }
                  }
                });
              }            
            } else {
              this.dialogRef.componentInstance.continue = false;
              this.dialogRef.componentInstance.errorMessage = "DIRECT_CONN.ERROR.NO_MACHINE";
            }
          }, 
          error: (error) => {
            console.warn(error);
            this.dialogRef.componentInstance.continue = false;
            this.dialogRef.componentInstance.errorMessage = "DIRECT_CONN.ERROR.NO_MACHINE";
          }
        });              
      });
    
  }

}


//Dialog
@Component({
  selector: 'direct-connection-dialog',
  templateUrl: './direct-connection-dialog.html',
  styleUrls: ['./direct-connection-dialog.scss']
})

export class DirectConnectionDialogComponent {

  loading: boolean;
  machinenr = '';
  continue: boolean = true;
  errorMessage: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private router: Router, private dialogRef: MatDialogRef<DirectConnectionDialogComponent>){
    //this.machinenr = data.machinenr.toUpperCase();
    this.loading = data.loading;
  }

  toMachineSelection() {
    this.dialogRef.close();
    window.location.href = "";
  }
}
